import { useEffect } from 'react';
import { useConnectionStatus } from './useConnectionStatus';
import { setGlobalLogFunction } from '@/lib/supabaseLogger';

/**
 * Hook that registers the connection status logger as the global Supabase logger.
 * Should be used once at the app root level.
 */
export function useSupabaseLogger() {
  const { addLog } = useConnectionStatus();
  
  useEffect(() => {
    setGlobalLogFunction(addLog);
    return () => setGlobalLogFunction(null);
  }, [addLog]);
}
